import React from 'react';
import { Link } from 'react-router-dom';

const ongoing = [
  'Managed website plans',
  'Business email administration',
  'Managed hosting',
  'Monthly support time',
  'Recurring technical direction'
];

const projects = [
  'Website builds and redesigns',
  'Email and website migrations',
  'Malware cleanup and recovery',
  'DNS, SSL, and hosting repairs',
  'One-off consulting reviews'
];

const OngoingManagement = () => {
  return (
    <section id="ways" className="scroll-mt-28 bg-[#FAF8F3] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 max-w-2xl">
          <div className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
            How the work is sold
          </div>
          <h2 className="text-4xl leading-tight sm:text-5xl">
            Monthly care, or a defined project.
          </h2>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          <div className="home-paper border border-[#174C3C] bg-[#174C3C] p-10 text-white sm:p-12">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
              Ongoing
            </div>
            <h3 className="mt-6 text-3xl leading-tight sm:text-4xl">
              Keep it running every month.
            </h3>
            <p className="mt-5 text-lg leading-relaxed text-white/75">
              For websites, email, and hosting that should not wait until
              something breaks.
            </p>
            <ul className="mt-10 space-y-4 text-lg font-medium text-white/90">
              {ongoing.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Link
              to="/digital-review"
              className="mt-10 inline-block text-lg font-bold text-[#D7B77A] underline decoration-2 underline-offset-[5px] transition-colors hover:text-white"
            >
              Discuss an ongoing plan
            </Link>
          </div>

          <div className="border border-[#17211E]/15 bg-white p-10 sm:p-12">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#3B7C6D]">
              Project
            </div>
            <h3 className="mt-6 text-3xl leading-tight sm:text-4xl">
              A job with a start and a finish.
            </h3>
            <p className="mt-5 text-lg leading-relaxed text-[#17211E]/70">
              For migrations, repairs, builds, and reviews.
            </p>
            <ul className="mt-10 space-y-4 text-lg font-medium text-[#17211E]/80">
              {projects.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Link to="/digital-review" className="home-link mt-10 inline-block text-lg">
              Request project help
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OngoingManagement;
